// extracted by mini-css-extract-plugin
export default {"info_back":"info_info_back__xgJzT","info_text":"info_info_text__+3Uxa","slideTransition":"info_slideTransition__ijQ9N"};